import { requestApi } from '@app/api';
import { withIdentityAccess } from '@app/api/paths';

interface PostUserPasswordResetResponse {
  message: string;
}

// eslint-disable-next-line import/prefer-default-export
export function postUserPasswordReset({
  email,
  token,
  password,
}: {
  email: string;
  token: string;
  password: string;
}): Promise<{ message: string }> {
  return requestApi<PostUserPasswordResetResponse>({
    url: withIdentityAccess('/user/password/reset'),
    method: 'POST',
    data: {
      email,
      newPassword: password,
      passwordResetToken: token,
    },
  }).then((response) => response.data);
}
